<template>
  <div class="col-lg-12 control-section">
    <div id="MeasureObjTree" class="tree-control-wrapper" v-show="treeShow">
      <ejs-treeview id='MeasureTreeForNoRealCreate' ref='MeasureTreeForNoRealCreate' :fields='fieldsOfNoRealTaskMeasureObjTree' :showCheckBox='true'></ejs-treeview>
    </div>
    <div id="tips" class="tree-control-wrapper" v-show="tipsShow" style="text-align:center; line-height:220px">
      {{this.text}}
    </div>
  </div>
</template>

<script>

import CommonUtil from "../../../../util/CommonUtil";

export default {
  name: 'MeasureTreeForNoRealTaskCreate',
  props: [
    'measureTreeShowType'
  ],
  data() {
    return {
      treeShow: false,
      tipsShow: true,
      text: this.$t('Pm.selectResourcePlease'),
      fieldsOfNoRealTaskMeasureObjTree: {
        dataSource: [{ children: [] }],
        id: 'id',
        text: 'text',
        child: 'children',
        expanded: 'state'
      }
    }
  },
  methods: {
    getMeasureObjTreeFoNoRealTaskCreate(neTypeId, neId) {

      const params = {
        neTypeCode: neTypeId,
        neId: neId
      }

      this.$axios.get(`/lte/ems/pm/noReal/task/buildNoRealTaskCounterTreeForCreate.html${CommonUtil.analyticParameter(params)}`).then((response) => {
        this.fieldsOfNoRealTaskMeasureObjTree = {
          dataSource: response.data,
          id: 'id',
          text: 'text',
          child: 'children',
          expanded: 'state'
        };
      });
    }
  },
  watch: {
    'measureTreeShowType': function(msg) {
      if (msg == 1) {
        this.tipsShow = false;
        this.treeShow = true;
      } else if (msg == 2) {
        this.tipsShow = true;
        this.treeShow = false;
        this.text = this.$t('Pm.selectResourcePlease');
      } else if (msg == 4) {
        this.tipsShow = true;
        this.treeShow = false;
        this.text = this.$t('Pm.resourceOffline');
      } else if (msg == 3) {
        this.tipsShow = true;
        this.treeShow = false;
        this.text = this.$t('Pm.taskAlreadyExists');
      }
    }
  }
};
</script>

<style>

</style>
